<template>
  <div class="news_content_list">
    <div class="news_content_list_box" v-for="board in boardData" :key="`news${board.wr_id}`"
         @click="goDetail(board.wr_id)">
      <div class="news_content_list_box_img" :style="`background-image:url(${returnImage(board)})`"></div>
      <div class="news_content_list_box_textBox">
        <div class="news_content_list_box_textBox_title">{{ board.wr_subject }}</div>
        <div class="news_content_list_box_textBox_text" v-html="decodeHtml(board.wr_content)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListNewsLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(256, 184, 'jpg')}`;
      }
    },
    decodeHtml(html = '') {
      let img_tag = /<IMG(.*?)>/gi;
      let video_tag = /<iframe(.*?)>(.*?)<\/iframe>/gi;
      html = html.replace(img_tag, "");
      html = html.replace(video_tag, "");

      return util.htmlDecode(html);
    },
    goDetail(idx) {
      this.$router.push(`/news/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>